/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import qs from 'qs';
import * as R from 'ramda';
import http from 'utils/http';
import { generateSearchParams } from 'utils/helpers/fetch';

const initialState = {
  currentAffiliate: null,
  error: '',
  pending: false,
  searchPtoList: [],
};

const reducers = {
  fetchSearchPTOsError(state, { payload }) {
    return R.assoc('error', payload, state);
  },
  fetchSearchPTOsPending(state, { payload }) {
    return R.assoc('pending', payload, state);
  },
  fetchSearchPTOsSuccess(state, { payload }) {
    return R.assoc('searchPtoList', payload, state);
  },
  setCurrentAffiliate(state, { payload }) {
    return R.assoc('currentAffiliate', payload, state);
  },
};

const { actions, reducer } = createSlice({
  initialState,
  name: 'searchPtos',
  reducers,
});

export const {
  fetchSearchPTOsError,
  fetchSearchPTOsPending,
  fetchSearchPTOsSuccess,
  setCurrentAffiliate,
} = actions;

let fetchController;
export const fetchSearchPTOs = () => (dispatch, getState) => {
  const { currentAffiliate } = getState().pto.searchPtos;
  const formattedAffiliate = currentAffiliate
    ? {
        affiliate: {
          companyCustomerIdName: currentAffiliate.customerIdName,
          dataCompanyId: currentAffiliate.dataCompanyId,
        },
      }
    : null;
  const paramString = qs.stringify(
    generateSearchParams(getState().pto.searchPtoFilters, formattedAffiliate),
    { allowDots: true, encode: false }
  );
  dispatch(fetchSearchPTOsPending(true));
  if (fetchController) fetchController.abort();
  fetchController = new AbortController();
  const { signal } = fetchController;
  http.get(`/product-transfer-orders/search?${paramString}`, { signal }).then(res => {
    dispatch(fetchSearchPTOsSuccess(res.data));
    dispatch(fetchSearchPTOsPending(false));
    dispatch(fetchSearchPTOsError({ error: '' }));
  });
};

export default reducer;
